/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import Quiz from 'material/embeds/embed/content/quiz/quiz_container';
import Poll from 'material/embeds/embed/content/poll/poll_container';
import Story from 'material/embeds/embed/content/story/story_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embed/content/content_styles';



/* ========== ~~~~~~~~~~ EMBED : CONTENT : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Content extends Component {
    displayUniqueContent() {
        switch (this.props.currentContentStatus.contentType) {
            case 'quiz':
                return <Quiz contentId={this.props.contentId} isEditable={this.props.isEditable} />;
            case 'story':
                return <Story contentId={this.props.contentId} isEditable={this.props.isEditable} />;
            case 'poll':
            default:
                return <Poll contentId={this.props.contentId} isEditable={this.props.isEditable} />;
        }
    }
    render() {
        return(
            <div className={`content ${this.props.classes.content} editable-${this.props.isEditable}`}>
                {this.displayUniqueContent()}
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Content);